export const updateMetaTags = ({ title, description, url }) => {
    if (title) document.title = title;
    
    let descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
        descriptionMeta.setAttribute('content', description || '');
    } else {
        descriptionMeta = document.createElement('meta');
        descriptionMeta.name = "description";
        descriptionMeta.content = description || '';
        document.head.appendChild(descriptionMeta);
    }
    
    // Update Open Graph tags if needed
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title || '');
    
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute('content', description || '');
    
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', url || '');
};
